import React, { useEffect, useRef, useState } from 'react';

/**
 * Mounts a <video> only after its container scrolls into view.
 * Prevents auto-download of every card's video on page load.
 * API mirrors a normal <video>: pass any video props (autoPlay, loop, etc.).
 */
const LazyVideo = ({ src, poster, className, rootMargin = '200px', ...videoProps }) => {
  const containerRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    if (typeof IntersectionObserver === 'undefined') {
      setInView(true);
      return;
    }
    const el = containerRef.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (entry.isIntersecting) {
            setInView(true);
            observer.disconnect();
            break;
          }
        }
      },
      { rootMargin }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [rootMargin]);

  return (
    <div ref={containerRef} className={className} style={{ backgroundColor: '#1b1f3b' }}>
      {inView ? (
        <video
          src={src}
          poster={poster}
          preload="metadata"
          className="w-full h-full object-cover"
          {...videoProps}
        />
      ) : poster ? (
        <img src={poster} alt="" className="w-full h-full object-cover" loading="lazy" decoding="async" />
      ) : null}
    </div>
  );
};

export default LazyVideo;
